import { SHStack } from "@components/design-systems";
import { CheckSVG, CrossSVG } from "@components/svgs";
import { MAAnalysisDataDTO } from "@models/managed-accounts/entities/step/fee";
import { AnalysisDataValue } from "@models/platform-analysis/enums/dataValue";
import { MissingDataCell } from "../missing-data-cell";

type Props = {
  value?: AnalysisDataValue | MAAnalysisDataDTO | boolean;
};
export const BooleanCell = ({ value }: Props) => {
  switch (value) {
    case AnalysisDataValue.True:
    case true:
      return <CheckSVG width={18} height={18} />;
    case AnalysisDataValue.False:
    case false:
      return (
        <SHStack marginRight={"3px"} marginBottom={"3px"}>
          <CrossSVG width={18} height={18} />
        </SHStack>
      );
    default:
      return <MissingDataCell />;
  }
};
